/**
* Makes sure phone number starts with "+", replaces 00 prefix if found
*/
const normalizePhoneNumber = phoneNumber => phoneNumber.replace(/^(\+|00)/, '+');

/**
 * Matches given phone number to the list of provided calling codes,
 * extracts the code if the match is found
 * @param phoneNumber {string}
 * @returns {string}
 */
const getCallingCodeFromNumber = (phoneNumber, callingCodes) => {
  let callingCode = '';
  const phoneNumberNormalized = normalizePhoneNumber(phoneNumber);
  if (callingCodes && callingCodes.length > 0) {
    callingCodes.forEach(option => {
      // check if phone number starts with one of the provided codes
      if (phoneNumberNormalized.indexOf(option.value) === 0) {
        callingCode = option.value;
      }
    });
  }
  return callingCode;
};

/**
 * Returns country name from the provided options
 * that corresponds to the code provided
 * @param callingCode {string}
 * @returns {string}
 */
const getCountryByCallingCode = (callingCode, callingCodes) => {
  let countryName = '';
  if (callingCodes && callingCodes.length > 0) {
    callingCodes.forEach(option => {
      // check if phone number starts with one of the provided codes
      if (option.value === callingCode) {
        countryName = option.country;
      }
    });
  }
  return countryName;
};

/**
 * Returns country code from the provided options
 * that corresponds to the calling code provided
 * @param callingCode {string}
 * @returns {string}
 */
const getCountryCodeByCallingCode = (callingCode, callingCodes) => {
  let returnCode = '';
  if (callingCodes && callingCodes.length > 0) {
    callingCodes.forEach(option => {
      // check if phone number starts with one of the provided codes
      if (option.value === callingCode) {
        returnCode = option.countryCode;
      }
    });
  }
  return returnCode;
};

/**
 * Sanitizes a give phone number by removing any
 * character that are not a number or whitespace.
 * Keeps leading + sign if previously present.
 * @param {string} phoneNumber
 * @returns {string}
 */
const sanitizePhoneNumber = phoneNumber => {
  const hasLeadingPlus = phoneNumber.indexOf('+') === 0;
  const sanitizedPhoneNumber = phoneNumber.replace(/[^\d\s]/g, '');
  return "".concat(hasLeadingPlus ? '+' : '').concat(sanitizedPhoneNumber);
};

export { getCallingCodeFromNumber, getCountryByCallingCode, getCountryCodeByCallingCode, normalizePhoneNumber, sanitizePhoneNumber };
